import loadConfig from "@/plugins/loadConfig.js";
import Vue from 'vue';
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
import i18n from "@/plugins/translations";
import router from '@/plugins/router';
import '@/scss/main.scss';
import 'dropzone/dist/dropzone.css';
import moment from 'moment-timezone';
import 'moment/dist/locale/nl';
import('@/plugins/maskDirective');
import('@/utils/filters');
import('@/plugins/vuelidate');
import('@/plugins/vuetifyDialog');
import('@/plugins/canPlugin');
import('@/plugins/timeMe');

moment.locale('nl');
moment.tz.setDefault('Europe/Amsterdam');

Vue.config.productionTip = false;

loadConfig().then(() => {
    loadPluginsAfterConfig().then(store => {
        new Vue({
            i18n,
            vuetify,
            router,
            store,
            render: h => h(App),
        }).$mount('#app')

        import('@/directives');
    });
});

async function loadPluginsAfterConfig() {
    await import('@/plugins/webSockets');
    await import('@/plugins/sentry');

    return import('@/store');
}
